
import { SQLCourse } from './types';
import { phase4Modules } from './phase4Modules';

export const SQL_PHASE4_COURSE: SQLCourse = {
  id: "sql-phase4-enterprise-mastery",
  title: "Enterprise SQL Mastery & Certification Preparation",
  description: "Master enterprise-grade SQL development with advanced security, collaboration, professional development, and comprehensive certification preparation for Oracle, Microsoft, PostgreSQL, and cloud platforms.",
  level: "expert",
  durationHours: 28,
  tags: ["Enterprise", "Security", "Collaboration", "Performance", "Certification", "Professional Development", "Oracle", "Microsoft", "PostgreSQL", "Cloud"],
  imageSrc: "/placeholder.svg",
  image: "/placeholder.svg",
  modules: phase4Modules,
  totalDuration: "14 hours",
  requirements: [
    "Completion of Advanced Analytics & Optimization course",
    "Enterprise development experience",
    "Security and compliance awareness",
    "Professional development goals"
  ]
};
